import { useSearchParams } from 'react-router';
import { NewExpenseFlow } from './NewExpenseFlow';

/** /gastos/nuevo — acceso directo del rendidor. `?informe=ID` preselecciona el informe; `?doc=UUID` retoma un documento en curso (refresh/aviso). */
export function NewExpensePage() {
  const [params, setParams] = useSearchParams();
  const informe = params.get('informe');
  const doc = params.get('doc');
  const gasto = params.get('gasto');
  return (
    <>
      <h1 style={{ marginBottom: 'var(--sp-3)' }}>Nuevo gasto</h1>
      <NewExpenseFlow key={`${informe ?? ''}:${gasto ?? ''}`} initialReportId={informe ? Number(informe) : null} docId={doc} resumeExpenseId={gasto ? Number(gasto) : null} onDocId={(id) => { const p = new URLSearchParams(params); if (id) p.set('doc', id); else p.delete('doc'); setParams(p, { replace: true }); }} />
    </>
  );
}
